namespace RioERP.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
